import { Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

function Upi() {
  const vht = useSelector((state) => state.qwickSilver);
  return (
    <>
      <Stack spacing={2}>
        <Stack spacing={1} direction='row'>
          <Typography>Upi Current Balance</Typography>
          <Typography color='primary'> {vht?.data?.response?.upi_current_balance || "--"}</Typography>
        </Stack>
        {/* <Stack spacing={1} direction='row'>
          <Typography>Last Order Date</Typography>
          <Typography color='primary' >{vht?.data?.response?.last_ka_order_at || "--"}</Typography>
        </Stack> */}
      </Stack>
    </>
  );
}

export default Upi;
